// Listicle page script (shipped as lp-listicle-<name>.js).
(function () {
  // Countdown (minutes : seconds): starts at 60:00 on every page load (Stefan, 2026-11-03).
  function countdown(root) {
    var timer = root.querySelector('gp-countdown-timer');
    if (!timer) return;
    var min = timer.querySelector('#minute .gp-countdown-number');
    var sec = timer.querySelector('#second .gp-countdown-number');
    var end = Date.now() + 60 * 60 * 1000;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (min) min.textContent = pad(Math.floor(left / 60));
      if (sec) sec.textContent = pad(left % 60);
      if (left > 0) setTimeout(tick, 250);
    }
    tick();
  }

  // Review carousel: the arrows move one card at a time (4 / 3 / 1 cards per view by screen size).
  function carousel(root) {
    [].forEach.call(root.querySelectorAll('gp-carousel'), function (c) {
      var slider = c.querySelector('.gem-slider');
      if (!slider) return;
      var items = [].slice.call(slider.children).filter(function (e) { return e.classList.contains('gem-slider-item'); });
      var i = 0;
      function perView() {
        var w = items[0].getBoundingClientRect().width;
        return Math.max(1, Math.round(slider.getBoundingClientRect().width / w));
      }
      function go(n) {
        i = Math.max(0, Math.min(items.length - perView(), n));
        var step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 0;
        items.forEach(function (e) {
          e.style.transition = 'transform .35s ease';
          e.style.transform = 'translateX(' + (-i * step) + 'px)';
        });
      }
      var prev = c.querySelector('.gem-slider-previous'), next = c.querySelector('.gem-slider-next');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      window.addEventListener('resize', function () { go(i); });
    });
  }

  function init() {
    [].forEach.call(document.querySelectorAll('.lp'), function (root) { countdown(root); carousel(root); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
